import React from 'react';
import { Link } from 'gatsby';

export const MixedLink = (props) => {
  const {
    buttonLabel,
    buttonLink,
    onClick,
    className,
  } = props;
  if (!buttonLink || !buttonLabel) return null;
  if (!buttonLink.uid) {
    return (
      <a
        key={buttonLink.url}
        href={buttonLink.url}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Navigate to ${buttonLabel.text}`}
      >
        <span>{buttonLabel.text}</span>
      </a>
    );
  }
  return (
    <Link
      key={buttonLink.uid}
      to={buttonLink.uid === 'home' ? '/' : `/${buttonLink.uid}/`}
      className={className}
      aria-label={`Navigate to ${buttonLabel.text}`}
      onClick={!onClick ? null : onClick}
    >
      <span>{buttonLabel.text}</span>
    </Link>
  );
};

export default MixedLink;
